module.exports = __webpack_public_path__ + "img/home_slide4.33a48152.jpg";